/* eslint-disable no-mixed-spaces-and-tabs,no-tabs */

xplenty.filter('secondsToTime', [
  function () {
    // var createHandler = function (divisor, noun, restOfString) {
    //     return function(diff) {
    //         var n = Math.floor(diff / divisor);
    //         var pluralizedNoun = noun + (n > 1 ? 's' : '');
    //         return "" + n + " " + pluralizedNoun + " " + restOfString;
    //     }
    // }

    // var formatters = [
    // 	{ threshold: -31535999, handler: createHandler(-31536000,	"year",     "" ) },
    // 	{ threshold: -2591999, 	handler: createHandler(-2592000,  	"month",    "" ) },
    // 	{ threshold: -604799,  	handler: createHandler(-604800,   	"week",     "" ) },
    // 	{ threshold: -172799,   handler: createHandler(-86400,    	"day",      "" ) },
    // 	{ threshold: -86399,   	handler: function(){ return      	"tomorrow"     } },
    // 	{ threshold: -3599,    	handler: createHandler(-3600,     	"hour",     "" ) },
    // 	{ threshold: -59,     	handler: createHandler(-60,       	"minute",   "" ) },
    // 	{ threshold: -0.9999,   handler: createHandler(-1,			"second",   "" ) },
    // 	{ threshold: 1,        	handler: function(){ return      	"just now" } },
    // 	{ threshold: 60,       	handler: createHandler(1,        	"second",	"" ) },
    // 	{ threshold: 3600,     	handler: createHandler(60,       	"minute",	"" ) },
    // 	{ threshold: 86400,    	handler: createHandler(3600,     	"hour",     "" ) },
    // 	{ threshold: 172800,   	handler: function(){ return      	"yesterday" } },
    // 	{ threshold: 604800,   	handler: createHandler(86400,    	"day",      "" ) },
    // 	{ threshold: 2592000,  	handler: createHandler(604800,   	"week",     "" ) },
    // 	{ threshold: 31536000, 	handler: createHandler(2592000,  	"month",    "" ) },
    // 	{ threshold: Infinity, 	handler: createHandler(31536000, 	"year",     "" ) }
    // ];

    return function (seconds) {
      if (!angular.isDefined(seconds)) return '';
      //   	var date = new Date();
      // date.setSeconds(date.getSeconds() + seconds);
      //       var diff = (((new Date()).getTime() - date.getTime()) / 1000);
      // for( var i=0; i<formatters.length; i++ ){
      // 	if( diff < formatters[i].threshold ){
      // 		return formatters[i].handler(diff);
      // 	}
      // }
      // throw new Error("exhausted all formatter options, none found"); //should never be reached
      return moment.duration(seconds, 'seconds').humanize();
    };
  },
]);
